module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h2', {
    staticClass: "h2c"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pageix",
      "title": "ix"
    }
  }, [_vm._v("CONTENTS")])]), _vm._v(" "), _c('table', [_c('tbody', [_c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/fm02"
    }
  }, [_vm._v("Foreword by Art Hansen")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toca"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("ONE")])])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_vm._v("THE GATES WERE CLOSED AFTER US")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec1"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("Manzanar Children’s Village")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec2"
    }
  }, [_vm._v("Resettlement in Los Angeles County")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec3"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("“Representative and Talented Nisei”")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec4"
    }
  }, [_vm._v("Resettlement in the Midwest")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec5"
    }
  }, [_vm._v("Resettlement on the East Coast")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec6"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("Seabrook Farms")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec7"
    }
  }, [_vm._v("Resettlement in the Near West")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec8"
    }
  }, [_vm._v("Making a Home in Temporary Housing")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec9"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("Bainbridge Island")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec10"
    }
  }, [_vm._v("Life in Temporary Housing")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01#sec11"
    }
  }, [_vm._v("Finding Work in Postwar America")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("TWO")])])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("WAR IS OVER")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Political Gains")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("Kurihara and Wakayama")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Victories and Defeats")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "epub:type": "pagebreak",
      "id": "pagex",
      "title": "x"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Japanese Americans in the U.S. Military")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("On the Move")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("Postwar Art and Pop Culture")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Love and Politics")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter02#sec8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Getting an Education")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("THREE")])])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocx"
  }, [_c('a', {
    attrs: {
      "href": "#/xhtml/chapter01"
    }
  }, [_c('strong', [_vm._v("TAKING A STAND")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("The Debate about Terminology")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Activism at the Local Level and Beyond")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Progress and Backlash")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Uncovering a Cover-Up")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Telling Their Stories")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Legal Remedies")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter03#sec7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A Path to Success")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("FOUR")])])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("NEVER AGAIN")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("“Journey to Our Community Healing”")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Formal Recognition")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Sacrifice and Loyalty")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Speaking Out")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_c('span', {
    staticClass: "gray"
  }, [_c('em', [_vm._v("“No Redress”")])])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/chapter04#sec6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Past, Present, and Future")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toca"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_c('span', {
    staticClass: "gray"
  }, [_vm._v("EPILOGUE")])])])])]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "tocx"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01",
      "title": "Link target outside of Sample"
    }
  }, [_c('strong', [_vm._v("MAKING DESERTS BLOOM")])])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("“No More Manzanars”")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Afterword")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Bibliography")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Image Credits")])])])]), _vm._v(" "), _c('tr', [_c('td', [_c('p', {
    staticClass: "toc"
  })]), _vm._v(" "), _c('td', [_c('p', {
    staticClass: "toc"
  }, [_c('span', {
    attrs: {
      "href": "#/xhtml/bm01#sec5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("About the Authors")])])])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ab8948c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/contents.vue
// module id = 72
// module chunks = 0